import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full h-full justify-center items-center"
}
const _hoisted_2 = {
  key: 2,
  class: "overflow-y-auto preview-container"
}
const _hoisted_3 = {
  key: 3,
  class: "h-full"
}

import { computed, onMounted, inject, ref, watch } from 'vue'
import Header from '../components/Header.vue'
import Builder from '../pages/Builder.vue'
import { useStore } from '../store'
import { useService } from '../service'
import { ISchedule } from '../types'
import { UISpin } from '@gohighlevel/ghl-ui'
import DevicePreview from 'common/components/Preview/DevicePreview.vue'
import { builderState } from 'common/composable/manageBuilderState'
import Versions from 'common/components/TemplateVersions/Versions.vue'
import { EMAIL_PREVIEW_ROUTES_NAMES } from 'common/utils/const_helper'
import { getHandleBarCustomValues } from 'common/utils/helper'
import ContactPanel from 'common/components/ContactPanel.vue'
import { appState } from '../../../common/composable/appState'
import { isEmpty } from 'lodash'

export default /*#__PURE__*/_defineComponent({
  __name: 'NestedRoutes',
  setup(__props) {

const route = inject<any>('route')
const store = useStore()
//  custom routing and loading components
const currentTabComponent = ref(appState.selectedPage)
const isLoading = ref(false)
const scheduleDetails = ref({})
const loadBuilder = computed(() => store.state.userId)
const scheduleId = appState.scheduleId
const service = useService()
const templateVersionsRef = ref()
const reloadBuilder = ref(false)
const disableRestoreVersionBtn = ref(true)

// contact variables
const showContactPreview = ref(false)
const selectedContact = ref(null)

if (scheduleId) {
  isLoading.value = true

  try {
    scheduleDetails.value = service
      .getEmailSchedule(String(scheduleId))
      .then(data => {
        // isLoading.value = false
        const schedule: ISchedule = data.data
        scheduleDetails.value = schedule
      })
      .catch(() => (isLoading.value = false))
  } catch (err) {
    console.warn(err)
  }
}

async function switchVersion() {
  if (templateVersionsRef.value?.switchVersions) {
    try {
      builderState.loader = true
      await templateVersionsRef.value.switchVersions()
      appState.selectedPage = EMAIL_PREVIEW_ROUTES_NAMES.EMAIL_TEMPLATE_BUILDER
      reloadBuilder.value = !reloadBuilder.value
    } catch (err) {
      console.error(err)
    } finally {
      builderState.loader = false
    }
  }
}
const previewHtml = ref()
const routeNames = EMAIL_PREVIEW_ROUTES_NAMES
const previewUrl = computed(() => builderState.previewUrl)
const templateId = computed(() => appState.templateId || '')
const tokenId = computed(() => store?.state?.tokenId || undefined)
const userId = computed(() => store?.state?.userId || undefined)
const locationId = computed(() => appState.locationId || undefined)
const senderPreferences = ref({})

const fetchEmailSettings = async () => {
  try {
    // avoid multiple calls
    if (!locationId.value || !isEmpty(senderPreferences.value)) return
    const { data } = await service.getSettings(locationId.value)
    if (data?.senderPreferences)
      senderPreferences.value = data?.senderPreferences
  } catch (error) {
    console.log(`Error while fetching email settings, error: ${error}`)
  }
}

watch(
  //first fetch should be call when token is available
  () => store?.state?.tokenId,
  (newVal, oldVal) => {
    if (newVal && !oldVal) {
      fetchEmailSettings()
    }
  }
)
onMounted(() => {
  if (store?.state?.tokenId) {
    fetchEmailSettings()
  }
})

watch(
  () => appState.selectedPage,
  (newVal, oldVal) => {
    if (newVal) currentTabComponent.value = newVal as string
  }
)
const updateCustomValues = async () => {
  if (previewUrl.value) {
    previewHtml.value = await getHandleBarCustomValues(
      previewUrl.value,
      store.state,
      selectedContact.value
    )
  }
}

watch(
  () => [
    previewUrl.value,
    tokenId.value,
    selectedContact.value,
    store.state.customValuesLocation,
  ],
  updateCustomValues,
  {
    immediate: true,
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, {
      onSwitchVersion: switchVersion,
      disableRestoreVersionBtn: disableRestoreVersionBtn.value,
      "sender-preferences": senderPreferences.value,
      "onContact:click": _cache[0] || (_cache[0] = ($event: any) => (showContactPreview.value = true)),
      onUpdateSenderPreference: _cache[1] || (_cache[1] = (val)=>senderPreferences.value = val)
    }, null, 8 /* PROPS */, ["disableRestoreVersionBtn", "sender-preferences"]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(UISpin))
        ]))
      : _createCommentVNode("v-if", true),
    (loadBuilder.value && !isLoading.value)
      ? (_openBlock(), _createBlock(Builder, {
          class: _normalizeClass({
      hidden: currentTabComponent.value !== _unref(routeNames).EMAIL_TEMPLATE_BUILDER,
    }),
          key: userId.value + reloadBuilder.value
        }, null, 8 /* PROPS */, ["class"]))
      : _createCommentVNode("v-if", true),
    (currentTabComponent.value === _unref(routeNames).EMAIL_PREVIEW_TEMPLATE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(DevicePreview, { previewHtml: previewHtml.value }, null, 8 /* PROPS */, ["previewHtml"])
        ]))
      : _createCommentVNode("v-if", true),
    (
      currentTabComponent.value === _unref(routeNames).EMAIL_TEMPLATE_VERSIONS && templateId.value
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(Versions, {
            ref_key: "templateVersionsRef",
            ref: templateVersionsRef,
            templateId: templateId.value,
            userId: userId.value,
            locationId: locationId.value,
            service: _unref(service),
            "onUpdate:version": _cache[2] || (_cache[2] = item => (disableRestoreVersionBtn.value = item.id === 0))
          }, null, 8 /* PROPS */, ["templateId", "userId", "locationId", "service"])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(ContactPanel, {
      service: _unref(service),
      state: _unref(store).state,
      "location-id": (_unref(appState).locationId as string),
      show: showContactPreview.value,
      "onUpdate:select": _cache[3] || (_cache[3] = val => (selectedContact.value = val)),
      "onUpdate:close": _cache[4] || (_cache[4] = ($event: any) => (showContactPreview.value = false)),
      to: _unref(appState).isModalDialog ? '#emailPreview' : 'body'
    }, null, 8 /* PROPS */, ["service", "state", "location-id", "show", "to"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})